import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';

const Frame = styled.div({
});

const Navigation = styled.div({
    margin: '1em 2em 1em 1em',
});

const Content = styled.div({
    padding: '0 3em',
});

const Back = (props: { onClick?: () => void }) => <Button onClick={props.onClick}><BackIcon /> Back</Button>;

export type SubPageProps = {
    onClick?: () => void;
}

export function SubPage(props: React.PropsWithChildren<SubPageProps>) {
    return (
        <Frame>
            <Navigation><Back onClick={props.onClick} /></Navigation>
            <Content>{props.children}</Content>
        </Frame>
    );
}
